import { Box } from "@mui/material";
import Home from "../../components/home/home";
function HomePage() {
  return <Box>{<Home />}</Box>;
}

export default HomePage;
